interface OidcConfig {
  authorizationEndpoint: string;
  clientId: string;
  id: number;
  iss: string;
  scope: string;
  tenant: string;
  tokenEndpoint: string;
}

let currentOidcConfig: OidcConfig | null = null;

export const setOidcConfig = (config: OidcConfig | null) => {
  currentOidcConfig = config;
};

export const getOidcConfig = () => {
  return currentOidcConfig;
};

export const getOidcConfigValue = (key: keyof OidcConfig) => {
  return currentOidcConfig?.[key] ?? null;
};

// Função auxiliar para obter a configuração completa do OIDC no formato esperado pelo AuthProvider
export const getOidcProviderConfig = () => {
  if (!currentOidcConfig) return null;

  return {
    authority: currentOidcConfig.iss,
    client_id: currentOidcConfig.clientId,
    redirect_uri: window.location.origin,
    response_type: "code",
    scope: currentOidcConfig.scope,
    post_logout_redirect_uri: window.location.origin,
    automaticSilentRenew: true,
    // metadata: {
    //   authorization_endpoint: currentOidcConfig?.authorizationEndpoint,
    //   token_endpoint: currentOidcConfig?.tokenEndpoint,
    // },
  };
};
